import React, { cloneElement } from 'react';
import IconEdit from '../svg/IconEdit';
import IconCopy from '../svg/IconClone';
import IconDelete from '../svg/IconDelete';
import IconRestore from '../svg/IconRestore';
import Tooltip from '../Tooltip';
import { gridBorder } from './styles';
import DataCell from './DataCell';

const ActionDataCell = ({
    rowIndex,
    colIndex,
    actionCount,
    accessor,
    onActionClick,
    data,
    statusAccessor,
    onActionIconLoad,
    onActionToolTip,
    scrollPxH,
    scrollPxV,
    isSticky,
    style,
    isHighlighted,
    onHover,
    component,
    actionIconSize,
    iconMarginTop = 0,
    rowHeight,
    deleteRowSelected,
    addToDelete,
    highlightedIdx,
    highlightOnClick = false,
    setHighlightedIdx
}) => {
    const cell = {
        ...gridBorder,
        width: 48,
        minWidth: 48,
        maxWidth: 48,
        height: rowHeight,
        padding: 0,
        textAlign: 'center',
        backgroundColor: isHighlighted
            ? '#dcffff'
            : deleteRowSelected
            ? '#FDF1D6'
            : rowIndex % 2 === 0
            ? '#f7f7f7'
            : '#ffffff',
        zIndex: 100 + (actionCount - colIndex) - rowIndex
    };
    let cellComponent;
    let disabled = false;
    let toolTipText = '';
    let toolTipWidth = 43;

    const customToolTip =
        typeof onActionToolTip === 'function'
            ? onActionToolTip(accessor.toLowerCase(), data)
            : null;

    if (customToolTip) {
        toolTipText = customToolTip?.toolTipText;
        toolTipWidth = customToolTip?.width;
    }

    const handleDelete = (e, data) => {
        (e.shiftKey || e.ctrlKey) && typeof addToDelete === 'function'
            ? addToDelete(e, data)
            : onActionClick('delete', data);
    };

    const toolTipWithIcon = (actionType, tipText) => {
        return (
            <Tooltip
                text={customToolTip ? toolTipText : tipText}
                marginTopAdjustment={customToolTip ? -26 : -6}
                marginLeftAdjustment={customToolTip ? 36 : 0}
                iconMarginTop={actionType !== 'restore' ? iconMarginTop : 0}
                style={{ width: toolTipWidth }}
            >
                {toolTipIconEdit(actionType)}
            </Tooltip>
        );
    };

    const toolTipIconEdit = (actionType) => {
        switch (actionType) {
            case 'edit':
                return (
                    <IconEdit
                        id={`edit${rowIndex}`}
                        size={actionIconSize}
                        disabled={disabled}
                        onClick={() => onActionClick('edit', data)}
                    />
                );
            case 'copy':
                return (
                    <IconCopy
                        id={`copy${rowIndex}`}
                        size={actionIconSize}
                        disabled={disabled}
                        onClick={() => onActionClick('copy', data)}
                    />
                );
            case 'delete':
                return (
                    <IconDelete
                        id={`delete${rowIndex}`}
                        size={actionIconSize}
                        disabled={disabled}
                        onClick={(e) => handleDelete(e, data)}
                    />
                );
            case 'restore':
                return (
                    <IconRestore
                        id={`restore${rowIndex}`}
                        size={actionIconSize}
                        disabled={disabled}
                        onClick={() => onActionClick('restore', data)}
                    />
                );
        }
    };

    switch (accessor.toLowerCase()) {
        case 'edit':
            disabled = onActionIconLoad('edit', data[statusAccessor], data);
            cellComponent = toolTipWithIcon('edit', 'Edit');
            break;
        case 'copy':
            disabled = onActionIconLoad('copy', data[statusAccessor], data);
            cellComponent = toolTipWithIcon('copy', 'Copy');
            break;
        case 'delete':
            disabled = onActionIconLoad('delete', data[statusAccessor], data);
            cellComponent = toolTipWithIcon('delete', 'Delete');
            break;
        case 'restore':
            disabled = onActionIconLoad('restore', data[statusAccessor], data);
            cellComponent = toolTipWithIcon('restore', 'Restore');
            break;
        case 'custom':
            cellComponent = cloneElement(component, {
                data: data
            });
            break;
    }

    return (
        <DataCell
            rowIndex={rowIndex}
            style={{ ...style, ...cell }}
            scrollPxH={scrollPxH}
            scrollPxV={scrollPxV}
            isSticky={isSticky}
            isHighlighted={isHighlighted}
            onHover={onHover}
            highlightedIdx={highlightedIdx}
            setHighlightedIdx={setHighlightedIdx}
            highlightOnClick={highlightOnClick}
        >
            {cellComponent}
        </DataCell>
    );
};

export default ActionDataCell;
